@if (showsTooltip() && tooltipText()) {
  <p
    class="tooltip"
    [style.top]="-topPosition() + 'px'"
    [style.left]="leftPosition() + 'px'">
    <span class="tooltip__text">
      {{ tooltipText() }}
    </span>
  </p>
}
